import {
  alerter,
  growlerInstance as growler
} from '@codev/helix-react';

class Retrier {
  constructor({maxTries = 3, mode = 'growler'} = {}) {
    this.tries = 0;
    this.maxTries = maxTries;
    this.mode = mode;
  }

  try = async ({
    action,
    retryMessage,
    retryAction,
    failLabel,
    failAction,
    channel,
    alertStyles,
  }) => {
    if (this.mode === 'growler' && !retryAction) {
      retryAction = action;
    }

    await this._tryAction(action);

    if (this.tries) {
      this.show({retryMessage, retryAction, failLabel, failAction, channel, alertStyles});
    }
  }

  show = async ({
    retryMessage,
    retryAction,
    failLabel,
    failAction,
    channel,
    alertStyles,
  }) => {
    if (!this.tries) {
      this.tries++;
    }
    this.mode === 'growler' ?
      this._showGrowl({retryMessage, retryAction, failLabel, failAction}) :
      this._showAlerter({retryMessage, retryAction, failLabel, failAction, channel, style: alertStyles});
  }

  _showAlerter = ({retryMessage, retryAction, failLabel, failAction, channel, style}) => {
    if (!this.tries) return;
    if (this.tries < this.maxTries) {
      alerter.alert({
        type: 'error',
        channel: channel,
        message: retryMessage,
        action: retryAction && (async () => {
          await this._tryMax(retryAction);
          if (this.tries) {
            this._showAlerter({retryAction, retryMessage, failLabel, failAction});
          }
        }),
        actionMessage: retryAction && 'Retry',
        style,
        suppressAlertType: true,
      });
    }
    else {
      alerter.alert({
        type: 'error',
        channel: channel,
        message: retryMessage,
        action: failAction,
        actionMessage: failLabel,
        style,
        suppressAlertType: true,
      });
    }
  }

  _showGrowl = ({retryMessage, retryAction, failLabel, failAction}) => {
    if (!this.tries) return;
    if (this.tries < this.maxTries) {
      growler.growl({
        type: 'error',
        message: retryMessage,
        action: {
          label: 'Retry',
          onClick: async () => {
            await this._tryMax(retryAction);
            if (this.tries) {
              this._showGrowl({retryAction, retryMessage, failLabel, failAction});
            }
          }
        }
      });
    }
    else {
      growler.growl({
        type: 'error',
        message: retryMessage,
        action: {
          label: failLabel,
          onClick: failAction
        }
      });
    }
  }

  _tryMax = async (action) => {
    while(this.tries < this.maxTries) {
      try {
        await action();
        this.tries = 0;
        break;
      } catch(error) {
        if (error.httpCode) {
          this.tries++;
        }
        else {
          throw error;
        }
      }
    }
  }

  _tryAction = async (action) => {
    try {
      await action();
      this.tries = 0;
    } catch (error) {
      if (error.httpCode) {
        this.tries++;
      }
      else {
        throw error;
      }
    }
  }
}

export default Retrier;